function Counter2_0() {
  return (
    <>
      <circle cx="4.5" cy="8" r="2.07895" stroke="#404040" strokeWidth="0.842105" />
      <circle cx="11.5" cy="8" r="2.07895" stroke="#404040" strokeWidth="0.842105" />
    </>
  );
}

export default Counter2_0;
